import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';
import { sectionHeading } from '../../styled';

export const PositionsContainerRow = styled(Row)`
  width: 100%;
`;

export const PositionsContentRow = styled(Row)`
  margin: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x1spacePx}px ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x4spacePx}px 0 0;
  `}
`;

export const PositionsHeader = styled.div`
  margin: 0 ${({ theme }) => theme.x2spacePx}px;
  h2 {
    margin-block-end: 0px;
    ${sectionHeading}
    ${media.lgUp`
      ${({ theme }) => theme.typography.massStrong};
      font-weight:700;
    `};
  }
  p {
    ${({ theme }) => theme.typography.small};
    ${media.lgUp`
      ${({ theme }) => theme.typography.base};
    `};
    color: ${({ theme }) => theme.color.spaceGray};
  }
`;

// The styles in this component are overwriting the styles from lever
// The :before contains an svg so it's converted to Base64
export const JobsContainer = styled.div`
  margin: ${({ theme }) => theme.x2spacePx}px
    ${({ theme }) => theme.x2spacePx}px 0;
  min-height: 350px;
  ${media.mdUp`
    min-height: 470px;
 `}
  ${media.lgUp`
     margin-top: ${({ theme }) => theme.x4spacePx}px;
  `}
  .lever-department {
    margin-bottom: ${({ theme }) => theme.x1spacePx}px !important;
    ${media.lgUp`
      margin-bottom: ${({ theme }) => theme.x4spacePx}px !important;
    `}
  }
  .lever-department-title {
    margin-bottom: ${({ theme }) => theme.x2spacePx}px !important;
    font-size: 18px !important;
  }
  .lever-team {
    margin-bottom: 0px !important;
  }
  .lever-team-title {
    display: none;
  }

  .lever-job {
    display: block;
    position: relative;
    :before {
      content: url("data:image/svg+xml,%3Csvg width='7' height='12' viewBox='0 0 7 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.0474 1.05025C0.656879 1.44078 0.656879 2.07394 1.0474 2.46447L4.58294 6L1.0474 9.53553C0.656879 9.92606 0.656879 10.5592 1.0474 10.9497C1.43793 11.3403 2.07109 11.3403 2.46162 10.9497L6.70426 6.70711C7.09478 6.31658 7.09478 5.68342 6.70426 5.29289L2.46162 1.05025C2.07109 0.659728 1.43793 0.659728 1.0474 1.05025Z' fill='%232394DF'/%3E%3C/svg%3E%0A");
      position: absolute;
      top: 5px;
      fill: ${({ theme }) => theme.color.brand01};
    }
    a {
      color: ${({ theme }) => theme.color.brand01} !important;
      text-decoration: none !important;
      font-size: 16px;
      margin-left: ${({ theme }) => theme.x2spacePx}px !important;
      ${media.lgUp`
        font-size: 18px;
      `}
    }
  }
  .lever-job-tag {
    display: none !important;
  }
`;
